import { Box } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { z } from "zod";
import type { ChatConversationSummary } from "../../../../../components/molecules/Chat/adapter";
import { QuotationChats } from "../../../../../components/molecules/QuotationChats";

const searchSchema = z.object({
  chat_notification_id: z.optional(z.string()).catch(""),
  negotiation_id: z.optional(z.coerce.number()).catch(undefined),
  tab: z.optional(z.enum(["chat"])).catch(undefined),
});

const RouteComponent: FC = () => {
  const { quotationId } = Route.useParams();
  const {
    chat_notification_id: chatNotificationId,
    negotiation_id: negotiationId,
  } = Route.useSearch();
  const navigate = Route.useNavigate();
  const [scrollToLatestRequest, setScrollToLatestRequest] = useState(0);

  useEffect(() => {
    if (chatNotificationId) {
      setScrollToLatestRequest((request) => request + 1);
    }
  }, [chatNotificationId]);

  const handleSelectionChange = (conversation: ChatConversationSummary) => {
    const isNegotiation = conversation.resource_type === "Vbuyer::Negotiation";
    void navigate({
      replace: true,
      resetScroll: false,
      search: (previous) => ({
        ...previous,
        negotiation_id: isNegotiation ? conversation.resource_id : undefined,
        tab: "chat",
      }),
    });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <QuotationChats
        onSelectionChange={handleSelectionChange}
        quotationId={Number(quotationId)}
        scrollToLatestRequest={scrollToLatestRequest}
        selectedNegotiationId={negotiationId}
      />
    </Box>
  );
};

export const Route = createFileRoute(
  "/_private/vbuyer/quotations/$quotationId/chat",
)({
  component: RouteComponent,
  validateSearch: searchSchema,
});
